import { useAuthContext } from "./AuthContext";

export const useAuth = () => useAuthContext();
